// extracted by mini-css-extract-plugin
export default {"mainPage":"MainPage_mainPage__CxpXc","mainPageContent":"MainPage_mainPageContent__dLgqD"};